import React from 'react';
import { Box } from '@mui/material';
import TeamCampaignsHeader from 'team/components/campaigns/TeamCampaignsHeader';
import TeamCampaignsList from 'team/components/campaigns/TeamCampaignsList';

const TeamCampaignsContainer = () => {
    return (
        <Box>
            <TeamCampaignsHeader />
            <TeamCampaignsList />
        </Box>
    );
};

export default TeamCampaignsContainer;
